module.exports = __webpack_public_path__ + "static/media/share.87a113aa.gif";